import React from 'react'
import { ImagesCarouselWrapperProps } from './types'
import './index.scss'

export const ImagesCarouselWrapper: React.FC<ImagesCarouselWrapperProps> = ({ id, children, imageAlign }) => {
  return (
    <div id={id} className={`images-carousel ${imageAlign == 'vertical' ? 'vertical' : 'horizontal'}`}>
      {Array.isArray(children)
        ? children.map((element) => {
            return element
          })
        : children}
    </div>
  )
}
